<template>
	<div class="plus_de" style="">
		<Tou></Tou>
		<el-breadcrumb class="w1500 pt-30 mb-33" separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
			<el-breadcrumb-item>GoodWe Plus</el-breadcrumb-item>
			<el-breadcrumb-item>Login</el-breadcrumb-item>
			<el-breadcrumb-item>{{gudingziduan.plus.InstallationRecord}}</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="w1500 bj-0 mb-71 pb-70 flex column">
			<div class="plus_dell flex a-center j-between p-50">
				<div class="tit-28 montserMedium tit">{{gudingziduan.plus.InstallationRecord}}</div>
				<div class="flex">
					<el-date-picker class="cur_pointer" :append-to-body="false" style="flex: 1;" v-model="date"
						type="month" prefix-icon="el-icon-time" placeholder="Date" @change="onChange1"></el-date-picker>
					<div class="rel ml-18  casca">
						<span class="iconfont icon-chanpinleixing abs tit-20 h100"
							style="z-index: 1;color: #6b6b6b; display: flex; align-items: center; padding-left: .15rem;"></span>
						<el-cascader popper-class="cascass" class="abs" :options="type" placeholder="Model" @change="onChange2"
							:props="{ multiple: true, checkStrictly: true }" collapse-tags>
						</el-cascader>
					</div>

				</div>
			</div>
			<div class="plus_derr pl-40 pr-40" style="flex: 1;">
				<el-table :data="tableData" style="width: 100%;">
					<el-table-column prop="createTime" :label="gudingziduan.plus.DATE" min-width="100"></el-table-column>
					<el-table-column prop="modelType" :label="gudingziduan.plus.MODELTYPE" min-width="120"></el-table-column>
					<el-table-column prop="totalCapacity" :label="gudingziduan.plus.CAPACITY" min-width="120"></el-table-column>
					<el-table-column prop="inverterNum" :label="gudingziduan.plus.NUMBER" min-width="120"></el-table-column>
					<el-table-column prop="point" :label="gudingziduan.plus.POINTS" min-width="120"></el-table-column>
				</el-table>
				<el-pagination class="flex j-center mt-60" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page.sync="sos.ye" :page-size="sos.jitiao"
					layout="prev, pager, next, jumper,slot" :total="zongshu">
					<span class="ml-10 cur_pointer" @click="goToPage">go</span>
				</el-pagination>
			</div>

		</div>
		<Foot></Foot>
	</div>
</template>

<script>
import { myInstallation, installationModel } from '@/api/user.js';
import Tou from '../../../zuzuzu/touss.vue'
import Foot from '../../../zuzuzu/foot.vue'
export default {
	data() {
		return {
			date: '',
			sos: { jitiao: 10, ye: 1 },
			zongshu: null,
			formattedDate: '',
			model: '',
			type: [],
			// type: [{
			// 	label: 'Introduction',
			// 	value: '1'
			// }, {
			// 	label: 'Installation',
			// 	value: '2'
			// }, {
			// 	label: 'Commissioning',
			// 	value: '3'
			// }, {
			// 	label: 'Monitoring',
			// 	value: '4'
			// }, {
			// 	label: 'Trouble shooting',
			// 	value: '5'
			// }, {
			// 	label: 'Solution',
			// 	value: '6'
			// }, {
			// 	label: 'Webinar replay',
			// 	value: '7'
			// }],
			tableData: [],
			gudingziduan:{}
		}
	},
	components: {
		Tou,
		Foot
	},
	watch: {
		'$store.state.cunyuanyan': {
		  handler(newValue, oldValue) {
			// console.log('语言已更新:', newValue);
			this.gudingziduan=this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'plus_details')
		  },
		  deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		}
	},
	created: function () {
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
		// console.log(this.gudingziduan,'plus')
	},
	mounted() {
		this.CSH()
		this.onModel()
	},
	methods: {
		CSH() {
			myInstallation({ 'pageNum': this.sos.ye-1,'pageSize': this.sos.jitiao,'date':this.formattedDate,'model':this.model}).then(shu=>{
				if(shu.code=='200') {
					this.tableData=shu.data.content
					this.zongshu = Number(shu.data.totalElements)
					// console.log(this.zongshu)
				}
			})
		},
		onModel() {
			installationModel().then(s => {
				for (var i in s.data) {
					this.type.push({
						label: s.data[i],
						value: s.data[i],
					});
				}
				// console.log(this.type)
			})
		},
		handleCurrentChange(e) {
			this.CSH()
		},
		handleSizeChange(e) {
		},
		onChange1(value) {
			console.log(value)
			  const date = new Date(value);
			  const year = date.getFullYear();
			  // const month = ((date.getMonth() + 1) - 1).toString().padStart(2, '0');
			  const month = (date.getMonth() + 1).toString().padStart(2, '0');
			  console.log(month)
			  this.formattedDate = `${year}-${month}`
			  this.CSH()
		},
		onChange2(e) {
			// this.model = value
			let types=''
			for(let i in e){
				 types+=e[i][0]+','
			}
			this.model=types.substring(0,types.length - 1)	
			console.log(this.model)

			  this.CSH()
		},
		goToPage() {
			this.handleCurrentChange(this.sos.ye)
		}
	}
}
</script>

<style lang="scss" scoped>
body {
	background-color: #F6F6F8 !important;
}



.plus_de {
	.plus_dell_fo {
		.el-input__icon {
			border-color: #E71218 !important;
		}
	}

	::v-deep .plus_dell {
		.el-picker-panel__icon-btn:hover {
			color: #E71218 !important;
		}

		.el-picker-panel {
			border-radius: 10px;
			box-shadow: 0px 0px 11px 0px rgba(3, 0, 0, 0.06);
			border: none;
		}

		.el-date-picker__header-label {
			font-family: "montserRegular";
		}

		.el-date-editor,
		.el-date-editor .el-input__inner {
			width: 2.58rem;
			min-width: 150px;
		}

		.el-date-editor {
			.el-input__prefix {
				left: .15rem;
			}

			.el-input__icon {
				font-size: var(--font18);
				color: #6b6b6b;
				display: flex;
				align-items: center;
			}
		}

		.el-month-table td .cell:hover {
			color: #E71218 !important;
		}

		.el-month-table td.today .cell {
			color: #E71218 !important;
			font-family: "montserRegular";
		}

		::-webkit-input-placeholder {
			color: #6b6b6b;
		}




		.el-date-editor .el-input__inner {
			height: 100%;
			border-radius: 100px;
			padding-left: .5rem;
			background: #F6F6F8;
		}


		.el-input.is-active .el-input__inner,
		.el-input__inner:focus {
			border-color: #E71218 !important;
		}

	}

	::v-deep .plus_derr {
		.el-table th {
			background-color: #F6F6F8;
			color: #333;
		}

	}

	::v-deep .el-pagination__editor.el-input .el-input__inner {
		background: #f5f5f5;
	}
}




// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width:767px) {
	.plus_dell {
		flex-wrap: wrap;
	}

	.plus_dell .tit {
		text-align: center;
		margin-bottom: .3rem;
		width: 100%;
	}
}
</style>